export const API_ENDPOINT = 'external-cpd';


// WEBPACK FOOTER //
// ./src/state/modules/external-cpd/configurations/endpoints.js